import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-warning\"><path d=\"M2.05 15 9 3l6.95 12H2.05Zm1.773-1.029h10.354L9 5.057l-5.177 8.914ZM9 13.154a.536.536 0 0 0 .395-.16.536.536 0 0 0 .159-.394.536.536 0 0 0-.16-.395.536.536 0 0 0-.394-.159.536.536 0 0 0-.395.16.536.536 0 0 0-.159.394c0 .157.053.289.16.395a.533.533 0 0 0 .394.159Zm-.514-1.794h1.028V7.932H8.486v3.428Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol